<template>
  <table class="table w-100">
    <thead>
      <tr>
        <th>ID</th>
        <th>Date/Term</th>
        <th>Totals</th>
        <th>Invoice Status</th>
        <th>Payments</th>
        <th>Action</th>
      </tr>
    </thead>

    <tbody>
      <tr v-if="billingInvoice.records.length < 1">
        <td colspan="6" align="center">No records found.</td>
      </tr>
      <tr v-for="(item, index) in billingInvoice.records" :key="index"
        :class="item.invoice_details.invoice_status === 'UNPAID' ? 'unpaid' : 'paid'">
        <td>
          <span>{{ item.invoice_details.invoice_id }}</span>
          <span>{{ "System ID: " + item.invoice_details.invoice_policy_id }}</span>
          <span v-if="item.invoice_details.term_status">
            {{ item.invoice_details.term_status }} [ {{ item.invoice_details.term_date | date_format("YYYY-MM-DD",
              "MM/DD/YYYY") }} ]
          </span>
        </td>
        <td>
          <span>{{ "Invoice Due Date: " + item.invoice_details.invoice_due_date }}</span>
          <span>Service Date: {{ item.invoice_details.invoice_start_date }} - {{ item.invoice_details.invoice_end_date
          }}</span>
        </td>
        <td>
          <span v-if="item.invoice_details.efee !== '$0.00'">{{ "Efees Amount: " + item.invoice_details.efee }}</span>
          <span v-if="item.invoice_details.late_fee !== '$0.00'">{{ "Late Fee Amount: " + item.invoice_details.late_fee
          }}</span>

          <span v-if="item.invoice_details.paid_amount !== '$0.00'">{{ "Paid Amount: " +
            item.invoice_details.paid_amount }}</span>
          <span v-if="item.invoice_details.overall_due_amount !== '$0.00'">
            <strong>{{ "Overall Due Amount: " + item.invoice_details.overall_due_amount }}</strong>
          </span>
        </td>
        <td>
          <strong>{{ item.invoice_details.invoice_status }}</strong>
        </td>
        <!-- <td>
          <div v-for="(billingData, billingIndex) in item.billing_details" class="billing-entry" :key="billingIndex">
            <span>{{ "Payment Date: " + billingData.payment_date }}</span>
            <span>{{ "Payment Method: " + billingData.method }}</span>
            <span style="display: inline-block;">Payment Status: <strong>{{ billingData.payment_status }}</strong></span>
            <div style="display: inline-block;" class="action-icons">
              <custom-button style="margin: -3px 7px;" v-if="!item.invoice_details.pay_now && shouldShowRefundButton(item)"
              @onClicked="openModal(item, billingData, 'invoiceRefundModal')" title="Refund"
              iconClass="fa-solid fa-money-bill-transfer" />
            </div>
          </div>
        </td> -->
        <!-- <td> -->

        <td>
          <template v-if="item.billing_details && item.billing_details.length > 0">
            <div v-for="(billingData, billingIndex) in item.billing_details" class="billing-entry" :key="billingIndex">
              <span>{{ "Payment Date: " + billingData.payment_date }}</span>
              <span>{{ "Payment Method: " + billingData.method }}</span>
              <span style="display: inline-block;">
                Payment Status:
                <strong>{{ billingData.payment_status.toUpperCase() }}</strong>
              </span>
              <span v-if="billingData.payment_amount">
                Amount: <strong>${{billingData.payment_amount}}</strong>
              </span>

              <span v-if= "billingData.payment_status ===payment_status.dispute" >
              Dispute Notes: <strong>  {{item.invoice_details.dispute_notes}} </strong>
              </span>

              <span v-if="billingData.payment_status == payment_status.failed">
                Payment Notes: <strong>{{ billingData.payment_notes }}</strong>
              </span>
              <div class="action-icons">
                <custom-button v-if="!item.invoice_details.pay_now && shouldShowRefundButton(item) &&
                  billingData.payment_status.toUpperCase() != 'REFUNDED' &&
                  billingData.payment_status.toUpperCase() != 'DISPUTE' &&
                  billingData.payment_status.toUpperCase() != 'FAILED' &&
                  billingData.payment_status.toUpperCase() != 'REFUND-PROCESSING'"
                  @onClicked="openModal(item, billingData, 'invoiceRefundModal')" title="Refund"
                  iconClass="fa-solid refund-icon fa-money-bill-transfer" />
              </div>
            </div>
          </template>

          <template v-else>
            <div>
              <span>Payment Status: <strong>UNPAID</strong></span>

            </div>
          </template>
        </td>
        <!--<td class="pay">
          <div class="action-icons">
            <template>
              <custom-button v-if="item.invoice_details.pay_now || (item.invoice_details.invoice_status == 'UNPAID' && item.is_oldest_unpaid )"
                @onClicked="payNow(item.invoice_details.invoice_id)" title="Pay Now"
                iconClass="fa-solid fa-money-check-dollar" />
            </template>
         
            <custom-button v-if="item.invoice_details.pay_now || (item.invoice_details.invoice_status == 'UNPAID' && item.is_oldest_unpaid )" 
              title="Schedule Payment" iconClass="fa-solid fa-calendar"
              @onClicked="openSchedulePaymentModal(item)" />
          </div>
        </td>-->
      </tr>
      <!-- <member-invoice-schedul-payment @onClosedModal="handleClose" 
      :invoiceDetails="selectedInvoice" /> -->
      <!--<member-invoice-schedul-payment  :invoiceDetails="selectedInvoice"
        @onClosedModal="handleClose" />-->

      <invoice-refund-modal :row="invoiceDetails.invoice_details" :billingDetails="billingDetails"
        @refundedAmount="handleRefund"
        :refundedAmount="getRefundedAmount(invoiceDetails.invoice_details?.invoice_id)" />
    </tbody>
  </table>
</template>

<script>
import InvoiceRefundModal from './InvoiceRefundModal.vue';
import { mapActions, mapGetters } from "vuex";
import { payment_status } from '@/utils/constant';
//import MemberInvoiceSchedulPayment from "@/views/MemberList/modal/MemberInvoiceSchedulPayment.vue";

export default {
  components: {
    InvoiceRefundModal,
  //  MemberInvoiceSchedulPayment
  },
  props: {
    billingInvoice: {
      required: false,
    },
  },
  data() {
    return {
      invoiceDetails: [],
      refundedAmounts: {},
      billingDetails: {},
      payment_status,
      selectedInvoice:{
        invoice_details:{}
      }
    };
  },
  computed: {
    ...mapGetters(["getRefundedAmount"]),

    shouldShowRefundButton() {
      return (item) => {
        if (!item || !item.invoice_details) return false;
        const invoiceId = item.invoice_details.invoice_id;
        const totalRefunded = this.getRefundedAmount(invoiceId);

        const policyAmount = parseFloat(item.invoice_details.policy_amount.replace(/[$,]/g, ''));
        return totalRefunded < policyAmount && policyAmount > 0;
      };
    },
    policyStatus() {
      return this.billingInvoice.policy_status
    }
  },
  methods: {
    ...mapActions(["addRefundedAmount"]),
    payNow(invoiceId) {
      const encodedInvoiceId = btoa(invoiceId);
      const paymentUrl = `${process.env.VUE_APP_PAYMENT_URL}pay-now?invoice_id=${encodedInvoiceId}`;
      window.open(paymentUrl, '_blank');
    },
    openModal(item, details, modalId) {
      this.invoiceDetails = item;
      this.billingDetails = details;
      this.$bvModal.show(modalId);
    },
    handleRefund(amount, invoiceId) {
      this.addRefundedAmount({ amount, invoiceId });
    },

    openSchedulePaymentModal(item) {
      this.selectedInvoice = item;
      this.$nextTick(()=>{
        this.$bvModal.show('memberInvoiceSchedulPayment'); // Open the modal
      })
      
    },
    handleClose() {
      console.log("Modal closed");
    },
    checkPayAccess(status) {
      if (status ==='WITHDRAWN' || status === 'TERMED') return false;
      return true
    },

  }
};
</script>

<style>
.table {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
}

.table th,
.table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.table td span {
  display: block;
  margin-bottom: 4px;
}

.table td div {
  margin-bottom: 8px;
}

.table td:empty::before {
  content: "-";
  color: #999;
}

.pay .custom-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #28a745;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s;
}

.pay .custom-button:hover {
  background-color: #218838;
}

.pay .custom-button[title='Refund'] {
  background-color: #dc3545;
}

.pay .custom-button[title='Refund']:hover {
  background-color: #c82333;
}

.billing-entry:not(:last-child) {
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
</style>